var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.visible)?_c('div',{staticClass:"loader__wrapper"},[_c('div',{staticClass:"lds-ripple"},[_c('div'),_c('div')]),_c('span',[_vm._v("Cargando Información, espera un momento")])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }